import _ from 'underscore';
import React from 'react';
import Joi from 'joi';

import { api as apiRequest } from '@culture/common-helpers/request';
import { addCleanCache } from '@culture/common-helpers/params';

import { getAdditionalBlocks } from '@culture/common-helpers/logic/blocks';
import getConfig from 'next/config';
import Template from 'pageTemplates/visit';

const { serverRuntimeConfig } = getConfig();

const VisitPage = (props) => <Template {...props} />;

const getBlocks = (rubricPage) => {
	const { citiesAndRegions } = rubricPage.blocks;

	const touristRoutesExcludeIds = citiesAndRegions
		.filter((item) => {
			const touristRubric = _(item.rubrics).findWhere({
				path: 'russia/tourist-routes'
			});
			return Boolean(touristRubric);
		})
		.map((item) => item._id);

	const blocks = {
		citiesAndRegions: {
			resource: 'touristRoutes',
			limit: 10,
			params: {
				statuses: ['published'],
				excludeIds: touristRoutesExcludeIds,
				fields: ['title', 'rubrics', 'thumbnailFile', 'name'].join()
			}
		},
		russianNature: {
			resource: 'institutes',
			limit: 10,
			params: {
				fields: [
					'accessibility',
					'city',
					'federalSubject',
					'isPushkinsCard',
					'locale',
					'name',
					'thumbnailFile',
					'title',
					'type',
					'virtualTours'
				].join(),
				statuses: ['published'],
				types: ['russiaImages'],
				rubrics: [serverRuntimeConfig.entities.atlasNatureRubric]
			}
		},
		virtualTours: {
			resource: 'virtualTours',
			limit: 4,
			sort: '-publishDate',
			params: {
				fields: ['title', 'thumbnailFile', 'url', 'federalSubject'].join(),
				statuses: ['published']
			}
		}
	};

	return blocks;
};

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		cleanCache: Joi.boolean().failover(false)
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const rubricPage = await apiRequest(
		'rubricPages/page',
		addCleanCache(
			{
				rubricPath: 'visit',
				blockFields: {
					searchPrompts: ['title', 'type', 'name', 'path', 'rubric'].join()
				},
				extendMixedByEntityType: true,
				isNew: true
			},
			params.cleanCache
		)
	);

	const blockData = getBlocks(rubricPage);

	const additionalBlocks = await getAdditionalBlocks(blockData);

	const { educationalInstitutes, educational, ...counters } = await apiRequest(
		'counters/entities',
		addCleanCache(
			{
				counters: [
					'museums',
					'theaters',
					'concertVenues',
					'zoos',
					'educationalInstitutes',
					'educational',
					'architecture',
					'russiaImages',
					'circuses',
					'religionHeritage',
					'objects',
					'libraries',
					'parks',
					'foreignObjects'
				],
				cached: true
			},
			params.cleanCache
		)
	);

	return {
		props: {
			blocks: { ...rubricPage.blocks, ...additionalBlocks },
			textBlocks: rubricPage.textBlocks,
			text: rubricPage.text,
			counters: {
				...counters,
				educationalInstitutes: educationalInstitutes + educational
			},
			rubric: rubricPage.rubric
		}
	};
}

export default VisitPage;
